module.exports = __webpack_public_path__ + "static/media/square-two.8fcda81b.png";